module.exports = __webpack_public_path__ + "media/img/vca/banner-main-2022-6eceba21d27265c78743dc60e2b98685.png";